import Header from './partials/Header.jsx';
import Footer from './partials/Footer.jsx';
import MasterLayout from './master/MasterLayout.jsx';
import SingleLayout from './master/SingleLayout.jsx';

export {MasterLayout, SingleLayout, Header, Footer};


// WEBPACK FOOTER //
// ./src/components/layout/index.js